import { autoinject, bindable } from 'aurelia-framework';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { 
	ServiceStructureService,
	ServiceNodeModel } from "../service-structure-service";
import { ResourcedNotificationService, NotificationType } from "../../../components/notifications/notification-service";
import { RowValidationErrorModel } from "../../../models/row-validation-error-model";
import { NodeModel } from "../../../models/node-model";
import { ResponseHandler } from "../../../utils/response-handler";

@autoinject
export class AddService {	
	@bindable structureId: string;
	@bindable parentService: ServiceNodeModel;

	@bindable newServiceName: string;
	@bindable newServiceCode: string;

	submitting = false;	
	saveErrors: RowValidationErrorModel[];

	private validationController: ValidationController;

	constructor(
		private element: Element,
		private serviceStructureService: ServiceStructureService,
		private notificationService: ResourcedNotificationService,
		private responseHandler: ResponseHandler,
		controllerFactory: ValidationControllerFactory) {

		this.validationController = controllerFactory.createForCurrentScope();

		ValidationRules
			.ensure((c: AddService) => c.newServiceName)
				.required()
				.withMessageKey('Service_AddService_ValidationError_ServiceNameIsRequired')
			.ensure((c: AddService) => c.newServiceCode)
				.required()
				.withMessageKey('Service_AddService_ValidationError_ServiceCodeIsRequired')
			.on(this);
	}

	addServiceToTree(model: ServiceNodeModel): void {
		const serviceNodeModel = NodeModel.createNew(model) as ServiceNodeModel;
		serviceNodeModel.code = model.code;

		this.element.dispatchEvent(new CustomEvent('service-added', {
				bubbles: true,
				detail: {
					addedService: serviceNodeModel,
					parentService: this.parentService
				}
			})
		);
	}

	submit(): void {
		this.validationController.validate({object: this})
			.then((result) => {
				if (!result.valid) {
					return;
				}

				this.submitting = true;
				this.saveErrors = null;
				let parentServiceId = this.parentService ? this.parentService.id : null;
				
				this.serviceStructureService.addService(this.structureId, {
						parentServiceId: parentServiceId,
						serviceName: this.newServiceName,
						serviceCode: this.newServiceCode
					})
					.then(response => {
						if (this.responseHandler.isSuccess(response.status)) {
							this.notificationService.push("ViewMessage_SaveSucceeded", NotificationType.Success);
							this.newServiceName = null;
							this.newServiceCode = null;

							response.json().then(this.addServiceToTree.bind(this));
						} else {
							response.json().then((errors) => {
								this.notificationService.push("Label_ErrorInSubmit", NotificationType.Error);
								this.saveErrors = RowValidationErrorModel.createFromValidationErrors(errors);
							});
						}
						this.submitting = false;
					});
			});
	}
}
